/** LancersTech brand tokens — use across app shell, auth, onboarding. */
export const BRAND_NAME = 'LancersTech';
export const BRAND_SHORT = 'LancersTech';
export const BRAND_PRODUCT = 'AI Internship LMS';
export const BRAND_LOGO = '/lancerstech-logo.png';
